import { createReducer, on } from '@ngrx/store';
import { initialCalculatedReportState } from './calculated-report.state';
import { CalculatedReportActions } from './calculated-report.actions';

export const calculatedReportReducer = createReducer(
  initialCalculatedReportState,

  // Reset store to initial value
  on(CalculatedReportActions.resetCalculatedReportStore, () => initialCalculatedReportState),

  // Load calculated report
  on(CalculatedReportActions.loadCalculatedReport, (state, { templateOid }) => ({
    ...state,
    loading: true,
    error: null,
    templateOid,
  })),

  // Load success
  on(CalculatedReportActions.loadCalculatedReportSuccess, (state, { data }) => ({
    ...state,
    loading: false,
    data,
    error: null,
  })),

  // Load failure
  on(CalculatedReportActions.loadCalculatedReportFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Set calculated report data (from resolver)
  on(CalculatedReportActions.setCalculatedReportData, (state, { data, templateOid }) => ({
    ...state,
    data,
    templateOid,
    loading: false,
    error: null,
  })),

  // Clear data
  on(CalculatedReportActions.clearCalculatedReportData, (state) => ({
    ...state,
    data: null,
    templateOid: null,
    error: null,
  })),
);
